export const mapCustomItemLabelForExport = (label: string = '') =>
  `カスタム項目-${label}`;
